import { Button } from "@website/ui/button";
import { useActions } from "@website/ui/datepicker/components/actions/actions.hook";
import styles from "@website/ui/datepicker/components/actions/actions.module.scss";
import { ActionsPropertiesType } from "@website/ui/datepicker/components/actions/actions.types";
import { FC, memo } from "react";

const Actions: FC<ActionsPropertiesType> = (properties) => {
  const { calendarLocale = "gregorian" } = properties;

  const { showTodayButtonProperties, changeCalendarLocaleButtonProperties } =
    useActions(properties);

  return (
    <div className={styles["container"]}>
      <Button {...changeCalendarLocaleButtonProperties}>
        تبدیل به {calendarLocale === "persian" ? "میلادی" : "پارسی"}
      </Button>
      <Button {...showTodayButtonProperties}>امروز</Button>
    </div>
  );
};

const ActionsMemoized = memo(Actions);
export { ActionsMemoized as Actions };
